<template>
	<div class="projectcase">
		<div class="img">
			<img :src="banner"/>
		</div>
		<!--路径-->
		<div class="container">
			<div class="path">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  	<el-breadcrumb-item>工程案例</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			
			<!--内容-->
			<div class="content">
				<div class="title">
					<ul>
						<li @click="selItem(item)" 
							:class="itemName===item.name?'active':''" 
							v-for="(item,index) in navlist"
							:key="index" >
							{{item.title}}
						</li>
					</ul>
				</div>
				<router-view/>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'newcenter',
				navlist: [
					{
						title: '精品案例',
						name: 'case',
						rou: '/ProjectCase/'
					},
					{
						title: '战略合作',
						name: 'cooperation',
						rou: '/ProjectCase/Cooperation'
					},
				],
				dataList:[],
				itemName:'case',
				sel:'',
				banner:''
			}
		},
		methods:{
			getItem(){
				var url = this.$route.path;
				var regstr = '/ProjectCase/';
				var str = url.replace(regstr, '');
				if(str == ''){
					this.itemName = 'case';
					this.title = '精品案例';
				}else if(str == 'Cooperation'){
					this.itemName = 'cooperation';
					this.title = '战略合作';
				}
			},
			getData(){
				this.itemName = this.$route.params.sel6;
			},
			selItem(item) {
				this.itemName = item.name; 
				this.$router.push(item.rou);
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'6',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner6;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getItem();
			this.getBanner();
		}

	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.projectcase{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding-left(20);
		.padding-right(20);
		.path{
			.margin-top(20);
			.margin-bottom(20);
			span{
				color: #00A0FF;
			}
		}
		.content{
			.margin-top(50);
			.title{
				text-align: center;
				ul{
					li{
						display: inline-block;
						.padding(10,20,10,20);
						background: #eee;
						.font-size(30);
						text-align: center;
					}
					.active{
						background: #00A0FF;
						color: #fff;
					}
				}
				P{
					.margin-top(50);
					.font-size(26);
					color: #00A0FF;
				}
				h3{
					.margin-top(10);
					.font-size(26);
					font-weight: 600;
					.margin-bottom(50);
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ProjectCase/ProjectCase.vue